// TODO: deprecated (D2CDiscountCodeDiscountType -> DiscountType)
export var D2CDiscountCodeDiscountType;
(function (D2CDiscountCodeDiscountType) {
    D2CDiscountCodeDiscountType["PERCENT"] = "PERCENT";
    D2CDiscountCodeDiscountType["AMOUNT"] = "AMOUNT";
})(D2CDiscountCodeDiscountType || (D2CDiscountCodeDiscountType = {}));
